import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Container,
  useTheme,
} from '@mui/material'

import React, { useEffect, useState } from 'react'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import { useParams, useNavigate } from 'react-router-dom'

import WTypography from '../Components/whiteTypography'
const mes_vehicules = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  float: 'none',
}

const Search = () => {
  const theme = useTheme()
  const { id, q } = useParams()
  const [querySearch, setQuerySearch] = React.useState([])
  const [queryData, setQueryData] = React.useState([])
  const [last, setLast] = React.useState(false)
  const [lifeGroupe, setLifeGroupe] = useState([])

  let navigate = useNavigate()

  useEffect(() => {
    fetchSearch()
    if (last) {
      last.target.style.backgroundColor = ''
    }
    setLast(false)
  }, [id, q])

  const fetchSearch = async () => {
    let url = `${urls.getSearch}?id=${id}&search=${q}`

    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setQuerySearch([...response.data])
      setQueryData([...response.data])
      let lifeapp = response.data.filter((v) => v.table_name === 'Life Apps')
      if (lifeapp.length > 0) {
        lifeapps(lifeapp[0].results)
      }
    }
  }

  const handelclick = (e) => {
    if (e.target.id === 'all') {
      setQuerySearch([...queryData])
    } else {
      setQuerySearch([...queryData.filter((item) => e.target.id === item.table_name)])
    }
    if (last) {
      last.target.style.backgroundColor = ''
    }
    setLast(e)
    e.target.style.backgroundColor = '#5e5e5e'
  }

  useEffect(() => {
    document.querySelectorAll('.search_mark').forEach((e) => {
      let re = new RegExp(q, 'ig')
      e.innerHTML = e.innerText.replace(re, (x) => `<mark>${x}</mark>`)
    })
  })
  const displayColumn = (value, name) => {
    // if(typeof(value)=== 'string'){

    //   value = String(value).replace(re,x=><Box sx={{display:'inline'}}>a</Box>)
    // }
    return name !== 'id' ? (
      <>
        <WTypography>{name}</WTypography>
        <Typography className="search_mark" color="secondary">
          {value || 'N/A'}
        </Typography>
      </>
    ) : (
      ''
    )
  }

  const handelNavigate = (type, obj) => {
    if (type === 'My plant') {
      navigate(`/Mesplantes/detail/${obj.id}`)
    }
    if (type === 'Documents') {
      navigate(`/documents?id=${obj.id}`)
    }
    if (type === 'Immobiliers') {
      navigate(`/domicile/monimmobilier/monbien/${obj.id}`)
    }
    if (type === 'Accounts') {
      navigate(`/compte/${obj.id}`)
    }
    if (type === 'Operation financière') {
      navigate(`/gestionoperations?id=${obj.id}`)
    }
    if (type === 'Véhicules') {
      navigate(`/domicile/vehicule/${obj.id}`)
    }
    if (type === 'Contacts') {
      navigate(`/MesContacts?id=${obj.id}`)
    }
    if (type === 'Evénement') {
      navigate(`/MonCalendrier?id=${obj.id}`)
    }
    if (type === 'Objectif') {
      navigate(`/mesobjectifs?id=${obj.id}`)
    }
    if (type === 'Mes recettes') {
      navigate(`/recette/${obj.id}`)
    }
    if (type === 'Bill of Ingredient') {
      navigate(`/recette/${obj.id}`)
    }
    if (type === 'Message') {
      navigate(`/inbox?m=${obj.id}`)
    }
  }
  const lifeapps = (item) => {
    let groupList = []
    let groups = []
    for (let r of item) {
      if (r.Groupe && r.display) {
        if (groups.indexOf(r.Groupe) === -1) {
          groups.push(r.Groupe)
          groupList.push({ nomgroupe: r.Groupe })
        }
      }
    }
    setLifeGroupe(groupList)
  }

  const Usedapps = (nomgroupe, app) => {
    return app.map((element, key) =>
      nomgroupe === element.Groupe && element.display ? (
        <Card
          key={key}
          sx={{
            backgroundColor: theme.palette.appBar.main,
            minWidth: { xs: 140, md: 180 },
            minHeight: { xs: 140, md: 180 },
            margin: '5px',
            '&:hover': {
              backgroundImage: 'radial-gradient(#001b42,#00001d)',
            },
          }}
        >
          <CardActionArea onClick={() => navigate(element.Lien)}>
            <CardContent>
              <Typography
                variant="subtitle1"
                sx={{
                  paddingTop: '5px',
                  color: theme.palette.appBar.color,
                }}
                className="search_mark"
              >
                {element.Nom}
              </Typography>
              <Typography
                variant="subtitle2"
                component="div"
                sx={{
                  fontWeight: '400',
                  color: 'gray',

                  lineHeight: '1.5',
                  // fontSize: "17px",
                }}
              >
                {element.SousTitre === '' ? <span>&nbsp;</span> : element.SousTitre}
              </Typography>
              <Box sx={{ float: 'right', paddingTop: '40px' }}>
                {element.Icone ? (
                  <>
                    {element.Nom === 'Mes Véhicules' ? (
                      <div style={mes_vehicules}>
                        <img
                          alt="logo"
                          height={50}
                          width={50}
                          style={{ marginRight: '20px' }}
                          src={element.Icone}
                        />
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{
                            fontWeight: '400',
                            color: theme.palette.appBar.color,

                            lineHeight: '1.5',
                            fontSize: '20px',
                          }}
                        >
                          {element.Indicateur}
                        </Typography>
                      </div>
                    ) : (
                      <img alt="logo" height={50} width={50} src={element.Icone} />
                    )}
                  </>
                ) : (
                  <>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        fontWeight: '400',
                        color: theme.palette.appBar.color,

                        lineHeight: '1.5',
                        fontSize: '20px',
                      }}
                    >
                      {element.Indicateur}
                    </Typography>
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        fontWeight: '400',
                        color: 'gray',

                        lineHeight: '1.5',
                        fontSize: '13px',
                      }}
                    >
                      {element.Footer}
                    </Typography>
                  </>
                )}
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      ) : null,
    )
  }
  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 2 }}>
        {querySearch.length > 0 ? (
          <>
            <Box sx={{ display: 'flex' }} overflow={'auto'}>
              {id === '0' ? (
                <WTypography
                  sx={{
                    whiteSpace: 'nowrap',
                    padding: '1px 5px',
                    cursor: 'pointer',
                    mr: 1,
                    color: 'white',
                  }}
                  id={'all'}
                  onClick={handelclick}
                >
                  Tout
                </WTypography>
              ) : (
                ''
              )}
              {queryData.map((item) => (
                <WTypography
                  sx={{
                    whiteSpace: 'nowrap',
                    padding: '1px 5px',
                    cursor: 'pointer',
                    mr: 1,
                    color: 'white',
                  }}
                  key={item.id}
                  id={item.table_name}
                  onClick={handelclick}
                >
                  {item.table_name}
                </WTypography>
              ))}
            </Box>
            {querySearch.map((item) =>
              item.table_name === 'Life Apps' ? (
                <Box key={item.id} borderRadius={1} p={1} mt={1}>
                  {/* <WTypography className='search_mark' variant="h6" p={1}>{item.object_name} | {item.type_of_object}</WTypography>   */}
                  {lifeGroupe.map((element, key) => (
                    <React.Fragment key={key}>
                      <Typography
                        className="search_mark"
                        key={key}
                        id={element.nomgroupe}
                        color="white"
                        variant="h6"
                        p={1}
                        mt={4}
                      >
                        {element.nomgroupe}
                      </Typography>

                      <Box display="flex" flexWrap="wrap">
                        {' '}
                        {Usedapps(element.nomgroupe, item.results)}{' '}
                      </Box>
                    </React.Fragment>
                  ))}
                </Box>
              ) : (
                <Box key={item.id} borderRadius={1} p={1} mt={1} overflow={'auto'}>
                  <WTypography className="search_mark" variant="h6" p={1}>
                    {item.object_name} | {item.type_of_object}
                  </WTypography>
                  {item.results.map((i) => (
                    <Box
                      border={'1px solid #a9a9a95e'}
                      onClick={() => handelNavigate(item.table_name, i)}
                      sx={{ cursor: 'pointer', '&:hover': { backgroundColor: '#a9a9a92e' } }}
                      display={'grid'}
                      key={i.id}
                      mb={1}
                      gridTemplateColumns={'auto auto auto auto auto'}
                      px={4}
                      py={2}
                    >
                      {i?.img && (
                        <Box sx={{ width: '170px', gridArea: '1 / 1 / 8 / 1' }}>
                          <img className="img-fluid" src={i?.img} alt="" />
                        </Box>
                      )}
                      {Object.keys(i).map(
                        (e, index) =>
                          e !== 'id' &&
                          e !== 'img' && (
                            <Box key={index} p={1}>
                              {displayColumn(i[e], e)}
                            </Box>
                          ),
                      )}
                    </Box>
                  ))}
                </Box>
              ),
            )}
          </>
        ) : (
          <WTypography>Aucun résultat trouvé</WTypography>
        )}
      </Container>
    </>
  )
}

export default Search
